import React from 'react';
import { type Error } from '@bbkAdminComponents/log-in-flow/log-in-types';
import { cs } from '@bbkAdminUtils/css-utils';

type Props = {
  error: Error;
};
export const LogInError: React.FC<Props> = ({ error: { title, message } }) => (
  <div
    className={cs(
      'tw-mx-3 tw-my-4 tw-p-4',
      'tw-text-sm',
      'tw-rounded tw-bg-cbrdanger-50 tw-text-cbrprimary-700'
    )}
  >
    {title && (
      <h2 className="tw-block tw-text-base tw-text-cbrdanger-400">{title}</h2>
    )}
    {message}
  </div>
);
